import { AppModule } from 'app/module';
import { IconBenefits } from 'module/benefitIcon/main';
import Template from './template.hbs';
import './styles.scss';

export class EbCompanyBenefitsItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            icons: '.m-iconBenefits',
            title: '.m-ebCompanyBenefitsItem__title',
            description: '.m-ebCompanyBenefitsItem__description',
            icon: '.m-ebCompanyBenefitsItem__icon',
            card: '.m-ebCompanyBenefitsItem__card',
            iconWrapper: '.m-ebCompanyBenefitsItem__iconWrapper',
        };
    }

    getPropsFromDom() {
        const newProps = {
            icon: {},
        };

        const iconType = this.dom.iconWrapper.getAttribute('data-icon-type');
        newProps.icon[iconType] = true;

        return {
            title: this.dom.title ? this.dom.card.getAttribute('data-title') : '',
            shortText: this.dom.description ? this.dom.card.getAttribute('data-description') : '',
            iconType: this.dom.iconWrapper.getAttribute('data-icon-type'),
            ...newProps };
    }

    subs() {
        if (this.dom.icons !== null) {
            this.icons = new IconBenefits(this.dom.icons);
        }
    }
}
